module.exports = __webpack_public_path__ + "img/assess-main-downArrow.1ac54b80.svg";